/**
 * Стоимость заказа с быстрой доставкой.
 */
export const fastDeliverySum = (window.app && window.app.fastDeliverySum) || 0
